import * as Sentry from "@sentry/nuxt";
import locationFromRequest from "#shared/utils/location";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $site, $api } = useNuxtApp()

  if ($site?.location) return

  const host = useRequestURL().host;
  const location = locationFromRequest(host);

  // Best-effort recovery: attempt to (re)load location once
  try {
    const info: any = await $api.location.info()
    if (info?.location) {
      const locationStore = useLocationStore()
      locationStore.setLocationInfo({
        location: info.location,
        settings: info.settings,
        images: info.images,
        integrations: info.integrations,
        tabs: info.tabs,
        colours: info.colours,
        menu: info.menu,
        customPages: info.customPages,
        domain: info.domain
      })
      return
    }
  } catch (e) {
    // fall through to redirect
  }

  Sentry.setTag("host", host)
  if ((location as any)?.id) Sentry.setTag("location_id", (location as any).id)
  if ((location as any)?.slug) Sentry.setTag("location_slug", (location as any).slug)
  Sentry.captureException(new Error('Location not found'))

  return navigateTo('https://book.app/not-found', { external: true })
})